import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/testimonials")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section
      className="py-20 md:py-28 border-b border-white/10 bg-[#0a0a0c]"
      data-testid="section-testimonials"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="eyebrow">Voices</div>
            <h2 className="font-display text-3xl md:text-5xl uppercase mt-3 tracking-tighter">
              What our clients say.
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-sm md:text-base">
            From e-rickshaw fleets and academic projects to CSR sponsors and
            municipal buyers — short notes from people we&apos;ve built for.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((t, i) => (
            <figure
              key={t.id}
              className="industrial-card p-7 relative flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Quote
                size={28}
                className="text-[#e63946] opacity-80"
              />
              <blockquote className="font-display text-lg md:text-xl uppercase mt-5 leading-snug tracking-tight">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between gap-3">
                <div>
                  <div className="text-sm font-semibold">{t.name}</div>
                  <div className="text-xs text-zinc-500 mt-1">
                    {t.role} · {t.location}
                  </div>
                </div>
                <span className="tag-chip tag-chip-red">{t.category}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
